
import { defineComponent, reactive, ref, toRefs, useContext, useRouter } from '@nuxtjs/composition-api'
import { useStore } from '@/useCases/useStore'
import { useValidation } from '@/useCases/validation'
import { type VForm } from '@/types/components'
import { setupAlertDialogCtx } from '@/components/dialogs/AlertDialog.vue'

export default defineComponent({
  layout: 'plain',

  setup() {
    const store = useStore()
    const router = useRouter()
    const { i18n, $logger } = useContext()
    const { idRules, commonPasswordRules } = useValidation()
    const { isOpenedAlertDialog, openAlertDialog } = setupAlertDialogCtx()

    const formInput = reactive({ username: '', password: '' })
    const isInputValid = ref(false)
    const form = ref<VForm | null>(null)

    const alertTitle = ref('')
    const alertMessage = ref('')

    const isLoading = ref(false)
    const isShowedPassword = ref(false)

    const signIn = async () => {
      if (!form.value?.validate()) return
      isLoading.value = true
      try {
        await store.dispatch('user/signIn', formInput)
        await router.push('/')
      } catch (err: any) {
        console.error(err)
        openAlertDialog()
        alertTitle.value = i18n.tc('alert.userNotFound.title', 1)
        alertMessage.value = i18n.tc('alert.userNotFound.message', 1)
        if (err.code !== 'UserNotFoundException' && err.code !== 'NotAuthorizedException') {
          // id, passwordの間違い以外のエラーをsentryに送信
          $logger.captureException(err)
        }
      } finally {
        isLoading.value = false
      }
    }

    store.dispatch('user/signOut')

    return {
      idRules,
      commonPasswordRules,
      isOpenedAlertDialog,
      ...toRefs(formInput),
      isInputValid,
      form,
      alertTitle,
      alertMessage,
      signIn,
      isLoading,
      isShowedPassword
    }
  }
})
